/**
 * Pola ról na kontakcie Salesforce (user_role.sf_name w onko-api).
 * Jedyne miejsce we froncie, w którym te nazwy mogą występować.
 * Front NIGDY ich nie zapisuje — role zmienia się wyłącznie przez
 * PUT/DELETE /users/:id/roles i POST /users/:id/role-selection,
 * a flagi w SF ustawia onko-api ze stanu bazy.
 */
export const SF_ROLE_FIELDS = [
  "Osoba_chora__c",
  "Opiekun__c",
  "Lekarz__c",
  "Partner_programu_beneficjenckiego__c",
] as const;

/** Zwraca kopię obiektu bez pól ról. undefined przechodzi bez zmian. */
export function stripSfRoleFields<T extends object>(
  obj: T | undefined
): T | undefined {
  if (!obj) return obj;
  const copy = { ...obj } as Record<string, unknown>;
  for (const field of SF_ROLE_FIELDS) {
    delete copy[field];
  }
  return copy as T;
}
